import styled, { space, device, themeGet } from '@styled'
import { Row } from '@ui/wrapper'

export const FooterWrap = styled.footer`
  background-color: ${themeGet('colors.gray.100')};
`

export const FooterTop = styled.div`
  padding-block-start: 40px;
  padding-block-end: 40px;
  ${device.medium} {
    padding-block-start: 60px;
    padding-block-end: 60px;
  }
  ${device.large} {
    padding-block-start: 80px;
    padding-block-end: 80px;
  }
`

export const FooterRow = styled(Row)`
  margin-inline-start: 34px;
  margin-inline-end: 34px;
`

export const FooterBottom = styled.div`
  padding-block-end: 30px;
`

export const FooterWidget = styled(
  // eslint-disable-next-line no-unused-vars
  ({ mt, mb, ml, mr, pt, pb, pl, pr, ...rest }) => <div {...rest} />
)`
  ${space};
  font-size: 15px;
  ${device.large} {
    font-size: 13px;
  }
  ${device.xlarge} {
    font-size: 15px;
  }
`

export const LogoWidget = styled.figure`
  margin-block-end: 30px;
`

export const TextWidget = styled.div``

export const FooterWidgetList = styled.ul`
  li {
    &:not(:last-child) {
      margin-block-end: 10px;
    }
  }
`
